var SystemFilter = {};
SystemFilter.init = function () {
  var systemSection = $('.js-section-system-filter');
  if (systemSection.length > 0) {
    $.each(systemSection, function () {
      var $this = $(this);
      var systemToggle = $this.find('#js-system-filter');
      var systemButton = $this.find('.filter-wrapper .btn');
      systemToggle.on('click', function () {
        $this.toggleClass('is-open');
      });
      systemButton.on('click', function () {
        $this.removeClass('is-open');
      });
    });
  }
};
SystemFilter.init();


// WEBPACK FOOTER //
// ./scripts/components/system-filter.js